import {
  discardVehicleFieldsRequested,
  forceVehicleSelectionLater,
  garageCleanupRequested,
  ignoreInexactFields,
  removalFromGarageRequested,
  replaceVehicleValue,
  setGarageRequested,
  vehicleDiscardingRequested,
  vehicleSelected,
  vehicleSpecificationNeeded,
} from 'Core/actions/fitmentSearch/index';
import { resetRequest } from 'Core/actions/request';
import { viewChangeRequested } from 'Core/actions/show';
import { garageDataSelector, selectedVehicleSelector } from 'Core/selectors/fitmentSearch/index';
import type { ReduxStateType } from 'Core/store';
import { VehicleCollection } from 'Models/index';
import uiConfig from 'Models/uiConfig/uiConfig';
import {
  removeItem,
  removeVehicleData,
  setForceVehicleSelectionLater,
  setItem,
  setVehicleData,
} from 'Utils/userStorage';
import keys from 'Utils/userStorageKeys';

import { epicFromHandlers } from './common';

export default epicFromHandlers(
  {
    [forceVehicleSelectionLater.type]: setForceVehicleSelectionLater,
    [garageCleanupRequested.type]: (arg) => {
      putVehicleAndGarageToStorage(arg);

      window.Convermax.onVehicleRemoved?.(VehicleCollection.empty);
    },
    [replaceVehicleValue.type]: (arg) => {
      if (!arg.action.meta.isolatedKey) {
        putVehicleAndGarageToStorage(arg);
      }
    },
    [vehicleDiscardingRequested.type]: putVehicleAndGarageToStorage,
    [resetRequest.type]: (arg) => {
      if (arg.action.payload?.discardVehicle) {
        putVehicleAndGarageToStorage(arg);
      }
    },
    [discardVehicleFieldsRequested.type]: putVehicleAndGarageToStorage,
    [ignoreInexactFields.type]: putVehicleAndGarageToStorage,
    [setGarageRequested.type]: putVehicleAndGarageToStorage,
    [removalFromGarageRequested.type]: (arg) => {
      putVehicleAndGarageToStorage(arg);
      window.Convermax.onVehicleRemoved?.(garageDataSelector(arg.state));
    },
    [vehicleSelected.type]: putVehicleAndGarageToStorage,
    [vehicleSpecificationNeeded.type]: putVehicleAndGarageToStorage,
    [viewChangeRequested.type]({ action: { payload } }) {
      if (payload === uiConfig.defaultView) {
        removeItem(keys.view);
      } else {
        setItem(keys.view, payload);
      }
    },
  },
  'localStorage',
);

function putVehicleAndGarageToStorage({ state }: { state: ReduxStateType }) {
  const selectedVehicle = selectedVehicleSelector(state);
  if (selectedVehicle.notNull) {
    setVehicleData(keys.vehicle, selectedVehicle.serializable);
  } else {
    removeVehicleData(keys.vehicle);
  }
  const garageData = garageDataSelector(state);
  if (garageData.size) {
    setVehicleData(keys.garageData, garageData.serializable);
  } else {
    removeVehicleData(keys.garageData);
  }
}
